import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';



  export default class GeneralParamsCostGridSubTasks extends Component{ 

    constructor(props){
      super(props);

      this.state={
          costgridsubtasks:[],
          modalTitle:"",
          costgridsubtaskname:"",
          costgridsubtaskid:0,

          CostGridSubTaskIdFilter:"",
          CostGridSubTaskNameFilter:"",
          costgridsubtasksWithoutFilter:[],
          costgridsubtaskNames: [],
          costgridsubtaskExists: false, 
      }
  }

  FilterFn(){
    var CostGridSubTaskIdFilter=this.state.CostGridSubTaskIdFilter;
    var CostGridSubTaskNameFilter = this.state.CostGridSubTaskNameFilter;

    var filteredData=this.state.costgridsubtasksWithoutFilter.filter(
        function(el){
            return el.costgridsubtaskid.toString().toLowerCase().includes(
                CostGridSubTaskIdFilter.toString().trim().toLowerCase()
            )&&
            el.costgridsubtaskname.toString().toLowerCase().includes(
                CostGridSubTaskNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({costgridsubtasks:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.costgridsubtasksWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({costgridsubtasks:sortedData});

}

changeCostGridSubTaskIdFilter = (e)=>{
  this.state.CostGridSubTaskIdFilter=e.target.value;
  this.FilterFn();
}
changeCostGridSubTaskNameFilter = (e)=>{
  this.state.CostGridSubTaskNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/costgridsubtasks/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({costgridsubtasks:data,costgridsubtasksWithoutFilter:data});
  });
}

fetchCostGridSubTaskNames() {
  axiosService.get('/costgridsubtasks/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const costgridsubtaskNames = data.map(item => item.costgridsubtaskname);
      this.setState({ costgridsubtaskNames: costgridsubtaskNames });
    })
    .catch(error => {
      console.error("Error fetching costgridsubtask names:", error);
    });
}

checkCostGridSubTaskExists = (event) => {
  const enteredCostGridSubTask = event.target.value.toLowerCase(); // Convert to lowercase
  const { costgridsubtaskNames } = this.state;
  const costgridsubtaskExists = costgridsubtaskNames.some((costgridsubtask) => costgridsubtask.toLowerCase() === enteredCostGridSubTask);
  this.setState({ costgridsubtaskExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchCostGridSubTaskNames();
}
changeCostGridSubTaskName =(e)=>{
  this.setState({costgridsubtaskname:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add CostGrid SubTask",
      costgridsubtaskid:0,
      costgridsubtaskname: "",
      costgridsubtaskExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit CostGrid SubTask",
      costgridsubtaskid:dep.costgridsubtaskid,
      costgridsubtaskname:dep.costgridsubtaskname,
      initialCostgridsubtaskname:dep.costgridsubtaskname,
      costgridsubtaskExists: false,
  });
}

createClick() {
  const { costgridsubtaskname, costgridsubtaskNames } = this.state;

  
  if (!costgridsubtaskname) {
    alert('CostGridSubTask Name is required');
    return;
  }

  if (costgridsubtaskNames.some(name => name.toLowerCase() === costgridsubtaskname.toLowerCase())) {
    alert('CostGridSubTask already exists. Please provide a unique CostGridSubTask Name.');
    return;
  }
  

  axiosService.post('/costgridsubtasks/', {
    costgridsubtaskname: costgridsubtaskname
  })
    .then(result => {
      alert('CostGrid SubTask created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){
  const { costgridsubtaskname, initialCostgridsubtaskname, costgridsubtaskNames } = this.state;

  // Check if any changes are detected
  if (
    costgridsubtaskname === initialCostgridsubtaskname
  ) {
    alert('No changes detected');
    return;
  }

  if (
    costgridsubtaskNames.some(
      (existingCostGridSubTask) =>
        existingCostGridSubTask.toLowerCase() === costgridsubtaskname.toLowerCase()
    )
  ) {
    alert('CostGridSubTask already exists. Please provide a unique CostGridSubTask Name.');
    return;
  }

  if (!costgridsubtaskname) {
    alert('CostGridSubTask Name is required');
    return;
  }


  axiosService.patch('/costgridsubtasks/'+id+'/',{
      costgridsubtaskid:this.state.costgridsubtaskid,
      costgridsubtaskname:this.state.costgridsubtaskname
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/costgridsubtasks/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      costgridsubtasks,
      modalTitle,
      costgridsubtaskid,
      costgridsubtaskname,
      costgridsubtaskExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridSubTaskIdFilter}
      placeholder="Filter"/>

      </div>
      CostGridSubTaskId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridSubTaskNameFilter}
      placeholder="Filter"/>

      </div>
      CostGridSubTask

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {costgridsubtasks.map(dep=>
      <tr key={dep.costgridsubtaskid} className="row-hover">
          <td className="table-text">{dep.costgridsubtaskid}</td>
          <td className="table-text">{dep.costgridsubtaskname}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>
          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >CostGridSubTask</span>
          <input
            type="text"
            className={`form-control ${costgridsubtaskExists ? "is-invalid" : ""}`}
            value={costgridsubtaskname}
            onChange={this.changeCostGridSubTaskName}
            onBlur={this.checkCostGridSubTaskExists}
            style={{ fontSize: "12px" }} 
          />
          {costgridsubtaskExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >CostGridSubTask already exists.</div>}
        </div>

        {costgridsubtaskid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {costgridsubtaskid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(costgridsubtaskid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

